import React, { useState } from "react";
import { Link } from "react-router-dom";

const Checkbox = ({ userName, email }) => {
  const [contractChecked, setContractChecked] = useState(false);
  const [privacyChecked, setPrivacyChecked] = useState(false);
  const [usageChecked, setUsageChecked] = useState(false);

  const openInNewTab = (url) => {
    const urlWithParams = `${url}?name=${encodeURIComponent(
      userName || ""
    )}&email=${encodeURIComponent(email || "")}&showDate=true`;
    window.open(urlWithParams, "_blank", "noopener,noreferrer");
  };

  return (
    <div className="w-full">
      <label className="label cursor-pointer flex justify-start gap-4">
        <input
          type="checkbox"
          checked={contractChecked}
          onChange={() => setContractChecked(!contractChecked)}
          className="checkbox [--chkbg:theme(colors.darkerGreen)] [--chkfg:black] checked:border-darkerGreen"
          required
          name="contractOfUse"
          value="true"
        />
        <span className="label-text text-sm text-grayy">
          <span
            className="text-sm text-darkerGreen underline"
            onClick={() => openInNewTab("/acik_riza_metni")}
          >
            Kişisel verilerin işlenmesine dair açık rıza metnini
          </span>{" "}
          okudum, onaylıyorum.
        </span>
      </label>
      <label className="label cursor-pointer flex justify-start gap-4">
        <input
          type="checkbox"
          checked={privacyChecked}
          onChange={() => setPrivacyChecked(!privacyChecked)}
          className="checkbox [--chkbg:theme(colors.darkerGreen)] [--chkfg:black] checked:border-darkerGreen"
          required
          name="privacyPolicy"
          value="true"
        />
        <span className="label-text text-sm text-grayy">
          <span
            className="text-sm text-darkerGreen underline"
            onClick={() => openInNewTab("/uyelik_kullanici_sozlesmesi")}
          >
            Üyelik ve kullanıcı sözleşmesini
          </span>{" "}
          okudum, onaylıyorum.
        </span>
      </label>
      <label className="label cursor-pointer flex justify-start gap-4">
        <input
          type="checkbox"
          checked={usageChecked}
          onChange={() => setUsageChecked(!usageChecked)}
          className="checkbox [--chkbg:theme(colors.darkerGreen)] [--chkfg:black] checked:border-darkerGreen"
          required
          name="contentPolicy"
          value="true"
        />
        <span className="label-text text-sm text-grayy">
          <span
            className="text-sm text-darkerGreen underline"
            onClick={() => openInNewTab("/kvkk")}
          >
            Aydınlatma metnini
          </span>{" "}
          okudum, onaylıyorum.
        </span>
      </label>
    </div>
  );
};

export default Checkbox;
